import { createBabylonScene } from "../rendering/create_babylon_scene";
import { DEFAULT_SKIN_TRANSLUCENCY } from "../rendering/skin_runtime";
import { createInvivoScenePackage } from "../scene/invivo_scene_package";
import { createInvivoMenu } from "./invivo_menu";

export async function createInvivoApp({
  canvas,
  sceneSlug,
}: {
  canvas: HTMLCanvasElement;
  sceneSlug?: string;
}): Promise<{ dispose(): void }> {
  const scenePackage = await createInvivoScenePackage({ sceneSlug });
  const runtime = await createBabylonScene({ canvas, scenePackage });
  const menu = createInvivoMenu({
    canvas,
    sceneTitle: scenePackage.manifest.title,
    anatomyTree: runtime.anatomyTree,
    initialSkinSetting: DEFAULT_SKIN_TRANSLUCENCY,
    onSkinChange: runtime.setSkinTranslucency,
    onDrapesVisibleChange: runtime.setDrapesVisible,
    onAnatomyNodeVisibleChange: runtime.setAnatomyNodeVisible,
  });

  return {
    dispose(): void {
      menu.dispose();
      runtime.dispose();
    },
  };
}
